module.exports = __webpack_public_path__ + "img/53.73b9ead4.png";